import * as yup from "yup";

export const HTTPS_URL_REGEX = /^https:\/\/[^\s]+$/;

const httpsUrl = yup
  .string()
  .trim()
  .nullable()
  .notRequired()
  .test(
    "starts-with-https",
    "URL must start with https://",
    (value) => !value || value.startsWith("https://")
  )
  .test(
    "no-spaces",
    "URL must not contain spaces",
    (value) => !value || !/\s/.test(value)
  )
  .test("valid-url", "Please enter a valid URL", (value) => {
    if (!value) return true;
    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  });

export const platformSettingsSchema = yup.object({
  calendlyLink: httpsUrl,
  interactionWebhookUrl: httpsUrl,
  dealWebhookUrl: httpsUrl,
});

export const emailSchema = yup
  .string()
  .trim()
  .email("Please enter a valid email address")
  .required("Please enter a valid email address");
